jQuery(document).ready(function ($) {

    //search
    const $menu = $('.search-widget');
    const $input = $('.search-widget [type=search]');

    $('.search-toggle').on('click', () => {
            $menu.addClass('active');
            $input.focus();
        }
    );

    var $carousel = $('.slideshow');
    $carousel.on('change.flickity', function (event, index) {

        if (matchMedia('screen and (min-width: 800px)').matches) {
            if ($('.slide').eq(-2).is('.is-selected')) {
                $(".next").prop("disabled", true);
            } else {
                $(".next").prop("disabled", false);
            }
            $('.is-selected').next().css('filter', 'blur(0px)');
            $('.is-selected').next().next().css('filter', 'blur(4px)');
            $('.is-selected').css('filter', 'blur(0px)');
            $('.is-selected').prev().css('filter', 'blur(0px)');
        }

    });


    // hide menu scroll down
    //
    //var prev = 0;
    //var $window = $(window);
    //var nav = $('.sticky-menu');
    //
    //$window.on('scroll', function(){
    //    var scrollTop = $window.scrollTop();
    //    nav.toggleClass('hidden', scrollTop > prev);
    //    prev = scrollTop;
    //});


});

